<template>
	<CommonLoading
		v-if="loading"
	/>
	<FilterComponent
		:title="'Agendamentos'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />
	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:useView= "false"
		:fileOnly="false"
		:inputsListing="inputs"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@delete-data-id= "deleteData"
		@new-alternative="newEntry"
		@view-alternative= "viewData"
		@edit-alternative= "editData"
		@filter="openFilter = true"
	/>

	<AgendamentosForm
		:open= "formOpen"
		:title= "'Agendamento'"
		:empresas= "empresas"
		:count= "count"
		:agendadores= "agendadores"
		:consultores= "consultores"
		@update-open= "formOpen = false"
		@apply-filters= "getFilterCount"
		@criar-agendamento= "createAgendamento"
	/>

	<AgendamentosCommonView
		:title="'Agendamento'"
		:open= "viewOpen"
		:data= "agendamentoData"
		@update-open= "viewOpen = false"
	/>

	<AgendamentosEdit
		:editData="editFormData"
		:agendadores= "agendadores"
		:open= "editOpen"
		@update-open= "editOpen = false"
		@delete-data= "removeAgendador"
		@save= "updateAgendador"
	/>
</template>
<script>
import Commonlisting from '@/components/generalcomponents/CommonListing';
import AgendamentosRepository from '@/services/AgendamentosRepository.vue';
import { pageVariables } from '@/views/insideviews/agendamentos/PageVariablesAgendamentos';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import AgendamentosForm from './AgendamentosForm.vue';
import EmpresasRepository from '@/services/EmpresasRepository.vue';
import SeguradosRepository from '@/services/SeguradosRepository.vue';
import AgendamentosCommonView from './AgendamentosCommonView.vue';
import Swal from "sweetalert2";
import GruposRepository from '@/services/GruposRepository.vue';
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import AgendamentosEdit from './AgendamentosEdit.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";

export default {
	name: 'AgendamentosView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.getAgendamentosPage);
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			formOpen : false,
			empresas: [],
			count: null,
			viewOpen: false,
			agendamentoData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			loading: false,
			editOpen: false,
			openFilter: false,
			agendadores:[],
			consultores:[],
			filters: [],
			filterFields: [
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome"
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.getAgendamentos(this.onlineUser.token,page,this.filters);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;
					this.getAgendadores();
					this.getEmpresas();

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {
					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error); 
			}
		},
		async onSendEditingData(data,id){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				console.log(data)
				const response = await agendamentosRepo.updateAgendamento(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.loading = false;
					this.pageData(this.getAgendamentosPage);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.deleteAgendamento(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.loading = false;
					this.pageData(this.getAgendamentosPage);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async getEmpresas() {
			const empresasRepo = new EmpresasRepository();
			try {
				const response = await empresasRepo.getEmpresasSelect(this.onlineUser.token, this.empresasSelectpage);
				if (response?.status === 200) {
					// Ordena os dados em ordem alfabética pelo nome (ajuste para a propriedade correta, se necessário)
					this.empresas = response.data.sort((a, b) => {
						const nameA = a.nome.toLowerCase(); // Troque "nome" pela propriedade correta
						const nameB = b.nome.toLowerCase();
						return nameA.localeCompare(nameB); // Comparação alfabética
					});
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}
		},
		async getAgendadores(){
			this.loading = true;
			const groupsRepo = new GruposRepository();
			try {
				const response = await groupsRepo.getGroupMembers(this.onlineUser.token,this.agendadoresPage);
				if (response?.status === 200) {
					this.agendadores = response.data;
					this.loading = false;
				} else {
					this.error = response?.message;
				}
				this.loading = true;
				const responseConsutores = await groupsRepo.getGroupMembers(this.onlineUser.token,this.consultoresPage);
				if (responseConsutores?.status === 200) {
					console.log(responseConsutores.data);
					this.consultores =responseConsutores.data;
					this.loading = false;
				} else {
					this.error = responseConsutores?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async getFilterCount(data){
			this.loading = true;
			const seguradoRepo = new SeguradosRepository();
			try {
				console.log(data)
				const response = await seguradoRepo.FilterSegurado(this.seguradosFilterPage,data,this.onlineUser.token);
				if (response?.status === 200) {
					this.loading = false;
					this.openFilter = false;
					this.count = response.data.count
					console.log(response.data)
				} else {
					this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async createAgendamento(data){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				console.log(data)
				const response = await agendamentosRepo.createAgendamento(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.loading = false;
					this.pageData(this.getAgendamentosPage);
					this.resetForm();
					this.mostrarAlerta();
				} else {
					this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async viewData(id){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.getAgendamento(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.loading = false;
					console.log(response)
					this.agendamentoData = response.data
					this.viewOpen = true
				} else {
					this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async editData(id){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				const response = await agendamentosRepo.getAgendamento(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					this.loading = false;
					this.editFormData = response.data
					this.editOpen = true;
				} else {
					this.loading = false;
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}	
		},
		async removeAgendador(email,id){
			console.log(email,id)
			this.loading = true;
			const data = {
				agendador_email: email
			}
			const agendamentosRepo = new AgendamentosRepository();
			try {
				console.log(data)
				const response = await agendamentosRepo.removeAgendador(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.loading = false;
					this.pageData(this.getAgendamentosPage);
					this.editData(id);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}
		},
		async updateAgendador(data,id){
			this.loading = true;
			const agendamentosRepo = new AgendamentosRepository();
			try {
				console.log(data)
				const response = await agendamentosRepo.updateAgendamento(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.loading = false;
					this.pageData(this.getAgendamentosPage);
					this.editData(id);
					this.mostrarAlerta();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				this.loading = false;
				handleUnauthorized(error);
			}
		},
		goTo(number){
			this.pageData(this.getAgendamentosPage+"?page="+number)
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		},
		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters
			this.openFilter = false;
			this.pageData(this.getAgendamentosPage);
		},
		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6',
			});
		},
		newEntry(){
			this.formOpen = true;
		}
	},
	components:{
		Commonlisting,
		AgendamentosForm,
		AgendamentosCommonView,
		CommonLoading,
		AgendamentosEdit,
		FilterComponent
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
